import Constants from '../Constants';
import lang from '../../../lang/translator';

export default function(value) {
  switch (parseInt(value)) {
    case Constants.BEHAVIOUR_TYPE_SHORT:
      return lang.get('dro.behaviour_type_short');
    case Constants.BEHAVIOUR_TYPE_LONG:
      return lang.get('dro.behaviour_type_long');
    default:
      return value;
  }
}


// WEBPACK FOOTER //
// ./src/modules/dro/filters/behaviourType.js